<template>
  <div>
    <a href="#" @click.prevent="loginNaver">
      <span class="sns-center">
        <span class="icon-sns icon-naver"></span>
        <span class="txt-sns">네이버로 시작하기</span>
      </span>
    </a>
    <div v-show="false" id="naverIdLogin"></div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-script-url */
import { setLibFile } from '@/common/plugins/sns.lib'
import utils from '@/common/util/utils'
import { parseUrl, stringify } from 'query-string'
import { get } from 'lodash'

const SIGN_UP_RESULT_CODE = '302'
export default {
  name: 'BtnNaver',
  props: {
    showProfileFn: {
      type: Function
    },
    closeOnSuccessFn: {
      type: Function
    },
    promotionCode: {
      type: String
    }
  },
  data () {
    return {
      loadingInterval: undefined,
      naverLogin: undefined
    }
  },
  methods: {
    login () {
      if (this.naverLogin.accessToken && this.naverLogin.accessToken.accessToken) {
        utils.login.loginProc(
          { userType: 'naver',
            userId: this.naverLogin.accessToken.accessToken,
            userPassword: '',
            saveId: '',
            autoLogin: '' }, (error) => {
            if (error.response.status === 551 && get(error, 'response.data.resultoptional', '') !== '' &&
                error.response.data.resultcode === SIGN_UP_RESULT_CODE) {
              const { url, query } = parseUrl(error.response.data.resultoptional)
              if (this.promotionCode !== '') query.promotioncode = this.promotionCode
              window.location.href = `${url}?${stringify(query)}`
            }
          })
          .then(({ data }) => {
            if (data.needselectprofile === 'y') { // 프로필 선택 화면이 필요하면
              this.showProfileFn()
            } else {
              this.closeOnSuccessFn()
            }
          })
      }
    },
    loginNaver () {
      let loginElement = document.getElementById('naverIdLogin_loginButton')
      if (loginElement) {
        loginElement.setAttribute('href', 'javascript:;')
        // eslint-disable-next-line
          if (/* @cc_on ! @ */ false) {
          // eslint-disable-next-line
            loginElement.fireEvent('onclick')
        } else {
          // Others
          let event = document.createEvent('MouseEvents')
          event.initEvent('click', false, true)
          loginElement.dispatchEvent(event)
        }
      }
    }
  },
  created () {
    var self = this
    window.loginResponse = function () {
      self.naverLogin.getLoginStatus((status) => {
        if (status) {
          self.login()
        }
      })
    }
    let loadingInterval = setInterval(() => {
      if (window.naver) {
        // window.naver 로드 완료 되면 Interval 취소
        clearInterval(loadingInterval)
        // LoginWithNaverId 선언
        this.naverLogin = new naver.LoginWithNaverId(
          {
            clientId: 'IMRF4m29ielhnUTZYGHL', // 개발자센터에 등록한 ClientID
            // 개발자센터에 등록한 callback Url
            callbackUrl: window.location.protocol + '//m.wavve.com/member/login_naver.html',
            isPopup: true, // 팝업을 통한 연동처리 여부
            callbackHandle: true, // callback 페이지 핸들링 여부
            loginButton: { color: 'green', type: 1, height: 60 } // 로그인 버튼의 타입을 지정
          }
        )
        // 설정정보를 초기화하고 연동 준비
        this.naverLogin.init()
      }
    }, 200)
    setLibFile(document, 'script', 'naver-jssdk', '//static.nid.naver.com/js/naveridlogin_js_sdk_2.0.0.js')
  }
}
</script>
